import React from 'react';
import styled from 'styled-components';

import { getQualificationLabel } from '~/utils';
import { media } from '~/styles/Utils';

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${media.s`
    flex-direction: row;
  `}
`;

const LightText = styled.div`
  color: ${(p) => p.theme.colors.greyblue};

  ${media.s`
    text-align: right;
    margin-left: auto;
    min-width: 100px;
  `};
`;

const Option = ({ qualification, label }) => {
  const qualificationLabel = getQualificationLabel(qualification);

  return (
    <OptionWrapper>
      {label} <LightText>{qualificationLabel}</LightText>
    </OptionWrapper>
  );
};

export default Option;
